import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createSkill } from "../../api/apiSkills";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لإنشاء مهارة جديدة
 */
export function useCreateSkill() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createSkillMutate,
        isPending,
    } = useMutation({
        mutationFn: createSkill,
        onSuccess: (response) => {
            toast.success(response.message || "Created successfully");
            queryClient.invalidateQueries({ queryKey: ["skills"] });
            navigate('/skills');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create skill");
        },
    });

    return {
        createSkillMutate,
        isPending,
    };
}